import { stylesByOrientation } from '../commonStyles';
import { CardSelectorVariant } from '../variants';
export const getHorizontalStyles = (FOUNDATIONS, FONT) => ({
    [CardSelectorVariant.HORIZONTAL]: {
        ...stylesByOrientation(FOUNDATIONS, {
            bodyContainer: {
                padding_right: FOUNDATIONS.spacing_300,
            },
            content: {
                padding_right: FOUNDATIONS.spacing_300,
            },
            expandedContentContainer: {
                display: 'block',
                padding_right: FOUNDATIONS.spacing_250,
            },
        }, false),
    },
});
//# sourceMappingURL=horizontal.js.map